import { useFormContext } from 'react-hook-form';
import { ReactNode, useState } from 'react';
import { useGetAvatarSrc } from '@mews-commander/utils';
import { Image, Stack } from '@optimus-web/core';
import { DropzoneField } from '@mews-commander/form';
import { ProductCategoryFormValues } from '../schemas/productCategoryFormSchema';

interface Props {
    imageId?: string | null;
    name: string;
    label?: ReactNode;
}

export const ProductCategoryDropzoneField = ({ imageId, name, label }: Props) => {
    const { trigger } = useFormContext<ProductCategoryFormValues>();
    const [isImageShown, setIsImageShow] = useState(true);

    const getImgSrc = useGetAvatarSrc();
    const imageUrl = getImgSrc(imageId);
    return (
        <Stack spacing="100" vertical>
            <DropzoneField
                label={label}
                name={name}
                accept=".png,.jpg,.jpeg"
                onChange={async () => {
                    await trigger('image');
                    setIsImageShow(false);
                }}
            />
            {isImageShown && imageId ? <Image src={imageUrl} /> : null}
        </Stack>
    );
};
